<mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons (page)="onPageChange($event)" aria-label="Select page of orders">
</mat-paginator>
<div class="py-2">
    <mat-divider></mat-divider>
</div>
<table mat-table matSort [dataSource]="ordersDataSource" class="order-list">

    <ng-container matColumnDef="orderNumber">
        <th mat-header-cell *matHeaderCellDef> # </th>
        <td mat-cell *matCellDef="let order"> {{order.id}} </td>
    </ng-container>

    <ng-container matColumnDef="amount_required">
        <th mat-header-cell *matHeaderCellDef> Amount required </th>
        <td mat-cell *matCellDef="let order"> {{getAmountRequired(order)}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row (click)="openOrder(row.id)" *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
